import { c as _c } from "react/compiler-runtime";
import { Badge, Box, Button, Card, HStack, Icon, Separator, Text, VStack, Wrap } from '@chakra-ui/react';
import { PitchSlideView } from '@src/components/sco/PitchDeckAuditor/model/types';
import { useState } from 'react';
import { LuCheck, LuCopy, LuPencilLine, LuThumbsUp, LuX } from 'react-icons/lu';
import { useBreakpointContext } from '../../utilities/BreakpointProvider';
export function SuggestedRewriteCard(t0) {
  const $ = _c(51);
  const {
    slide,
    onAccept,
    onClear,
    loading: t1
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const [copied, setCopied] = useState(false);
  const isAccepted = !!slide.acceptedRewrite;
  const rewriteText = slide.acceptedRewrite || slide.suggestedRewrite;
  const canMutate = !!slide.auditSlideId;
  if (!rewriteText) {
    return null;
  }
  let t2;
  if ($[0] !== rewriteText) {
    t2 = () => {
      navigator.clipboard?.writeText(rewriteText).catch(_temp);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    };
    $[0] = rewriteText;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const copyRewrite = t2;
  const t3 = isMobile ? 4 : 8;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <HStack color="orange.fg" gap={2}><Icon as={LuPencilLine} boxSize={4} /><Text fontWeight="semibold" textStyle="lg">Suggested rewrite</Text></HStack>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isAccepted) {
    t5 = isAccepted && <Badge colorPalette="green" padding="4px 8px" size="sm" variant="solid"><LuCheck />Accepted</Badge>;
    $[3] = isAccepted;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <HStack gap={2} justify="space-between" wrap="wrap">{t4}{t5}</HStack>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      base: "lg",
      md: "xl"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== rewriteText) {
    t8 = <Text fontFamily="longform" fontSize={t7} fontStyle="italic" mt={3}>“{rewriteText}”</Text>;
    $[8] = rewriteText;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== slide.rewriteAnnotations) {
    t9 = slide.rewriteAnnotations.length > 0 && <Wrap gap={1.5} mt={3}>{slide.rewriteAnnotations.map(_temp2)}</Wrap>;
    $[10] = slide.rewriteAnnotations;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== slide.whyThisWorks) {
    t10 = slide.whyThisWorks.length > 0 && <Card.Root mt={4} variant="subtle"><Card.Body><HStack color="green.fg" gap={2} mb={2}><Icon as={LuThumbsUp} boxSize={4} /><Text textStyle="labelXs">Why the rewrite works</Text></HStack><VStack align="stretch" gap={1.5} mt={2}>{slide.whyThisWorks.map(_temp3)}</VStack></Card.Body></Card.Root>;
    $[12] = slide.whyThisWorks;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== slide.investorObjection) {
    t11 = slide.investorObjection && <><Box bgColor="colorPalette.card/50" borderRadius="md" mt={4} padding={4}><Text color="fg.muted" fontSize="sm"><Text as="span" color="fg" fontWeight="semibold">The investor will say:{" "}</Text>{slide.investorObjection}</Text></Box></>;
    $[14] = slide.investorObjection;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Separator mt={4} />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = !canMutate || isAccepted;
  let t14;
  if ($[17] !== onAccept || $[18] !== rewriteText || $[19] !== slide.auditSlideId) {
    t14 = () => slide.auditSlideId && onAccept(slide.auditSlideId, rewriteText);
    $[17] = onAccept;
    $[18] = rewriteText;
    $[19] = slide.auditSlideId;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <LuCheck />;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = isAccepted ? "Accepted" : "Accept rewrite";
  let t17;
  if ($[22] !== loading || $[23] !== t13 || $[24] !== t14 || $[25] !== t16) {
    t17 = <Button disabled={t13} loading={loading} size="lg" variant="cta" onClick={t14}>{t15}{t16}</Button>;
    $[22] = loading;
    $[23] = t13;
    $[24] = t14;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== canMutate || $[28] !== isAccepted || $[29] !== loading || $[30] !== onClear || $[31] !== slide.auditSlideId) {
    t18 = isAccepted && canMutate && <Button loading={loading} size="lg" variant="outline" onClick={() => slide.auditSlideId && onClear(slide.auditSlideId)}><LuX />Undo</Button>;
    $[27] = canMutate;
    $[28] = isAccepted;
    $[29] = loading;
    $[30] = onClear;
    $[31] = slide.auditSlideId;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== copied) {
    t19 = copied ? <LuCheck /> : <LuCopy />;
    $[33] = copied;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const t20 = copied ? "Copied" : "Copy";
  let t21;
  if ($[35] !== copyRewrite || $[36] !== t19 || $[37] !== t20) {
    t21 = <Button size="lg" variant="outline" onClick={copyRewrite}>{t19}{t20}</Button>;
    $[35] = copyRewrite;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t17 || $[40] !== t18 || $[41] !== t21) {
    t22 = <HStack gap={2} mt={4}>{t17}{t18}{t21}</HStack>;
    $[39] = t17;
    $[40] = t18;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t10 || $[44] !== t11 || $[45] !== t22 || $[46] !== t3 || $[47] !== t6 || $[48] !== t8 || $[49] !== t9) {
    t23 = <Card.Root bgColor="colorPalette.card/50" variant="elevated"><Card.Body padding={t3}>{t6}{t8}{t9}{t10}{t11}{t12}{t22}</Card.Body></Card.Root>;
    $[43] = t10;
    $[44] = t11;
    $[45] = t22;
    $[46] = t3;
    $[47] = t6;
    $[48] = t8;
    $[49] = t9;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
}
function _temp3(reason, idx) {
  return <HStack key={idx} align="flex-start" gap={2}><Icon as={LuCheck} boxSize={4} color="green.fg" mt={0.5} /><Text color="fg.muted" fontSize="sm">{reason}</Text></HStack>;
}
function _temp2(annotation) {
  return <Badge key={`${annotation.phrase}-${annotation.label}`} size="sm">{annotation.phrase}<Text as="span" fontWeight="normal" opacity={0.7}>· {annotation.label}</Text></Badge>;
}
function _temp() {}